// extracted by mini-css-extract-plugin
export default {"intro":"SectionIntro_intro__WYZVs","label":"SectionIntro_label__3vSvc","title":"SectionIntro_title__4+YE7","description":"SectionIntro_description__GOXRP"};